/**
 * Centralized debug logging utility
 * @param {string} context - Context/module name (e.g., 'Analytics', 'Cart', 'User')
 * @param {string} icon - Emoji icon for the log type
 * @param {string} message - Log message
 * @param {Object} data - Optional data to log
 */
const debugLog = (context, icon, message, data = null) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    if (data) {
      // eslint-disable-next-line no-console
      console.log(`${icon} [${context}] ${message}`, data)
    } else {
      // eslint-disable-next-line no-console
      console.log(`${icon} [${context}] ${message}`)
    }
  }
}

/**
 * Create a context-specific debug logger
 * @param {string} context - Context/module name
 * @returns {Function} Debug logger function with context pre-filled
 */
const createDebugLogger = (context) => (icon, message, data = null) =>
  debugLog(context, icon, message, data)

export { debugLog, createDebugLogger }